import i18n from '../i18n';
import { translateText } from './translateText';

const sourceText = new WeakMap<Phaser.GameObjects.Text, string>();

export function setLocalizedCanvasText(object: Phaser.GameObjects.Text, source: string) {
  if (!sourceText.has(object)) {
    const update = () => object.setText(translateText(i18n, sourceText.get(object) || ''));
    i18n.on('languageChanged', update);
    object.once('destroy', () => i18n.off('languageChanged', update));
  }
  sourceText.set(object, source);
  object.setText(translateText(i18n, source));
  return object;
}
